import classNames from 'classnames';
import { Button, Icon, Text } from 'worldover/ui-components';

const NewsletterCard = ({
  title,
  image,
  imageClassName,
}: {
  title: string;
  image: string;
  imageClassName?: string;
}) => {
  return (
    <div
      className={classNames(
        'grid grid-rows-[121px,auto] gap-[10px]',
        'h-[222px] w-[185px]',
        'p-[10px]',
        'rounded-lg',
        'bg-white',
      )}
    >
      <div className='w-full h-full overflow-hidden'>
        <img
          src={image}
          alt={title}
          className={classNames('w-full h-full object-cover', imageClassName)}
        />
      </div>
      <Text variant='smallSemi' color='text-slate-700'>
        {title}
      </Text>
    </div>
  );
};

export const LandingPageFreeTierNewsletterCard = () => {
  return (
    <div className='flex flex-col gap-[14px]'>
      <div className='flex flex-row gap-2'>
        <Icon
          name='OutlineBookOpenIcon'
          height={18}
          width={18}
          className='text-slate-400 translate-y-[1px]'
        />
        <Text variant='bodySemi' color='text-slate-400'>
          Learn
        </Text>
      </div>
      <div
        className={classNames(
          'h-[320px]',
          'p-[2px]',
          'rounded-lg',
          'overflow-hidden',
          'box-border',
          'shadow-lg',
          'cursor-pointer',
          'glint-effect',
        )}
        style={{
          backgroundImage: 'linear-gradient(90deg, #E2E8F0 0%, #11192B 100%)',
        }}
      >
        <a
          href='https://www.worldover.io/newsletter'
          target='_blank'
          rel='noopener noreferrer'
          className={classNames(
            'relative',
            'grid grid-flow-col place-items-center h-full w-full',
            'w-full',
            'rounded-lg',
            'box-border',
            'overflow-hidden',
          )}
          style={{
            backgroundColor: '#0F172A',
            backgroundImage:
              "linear-gradient(300deg, transparent 0%, #242E3D 60%), url('/images/lines.png')",
          }}
        >
          <div className='flex flex-col justify-end h-full w-full p-[40px]'>
            <div className='flex flex-col gap-[20px]'>
              <div className='flex flex-col gap-[20px]'>
                <Text variant='bodyReg' color='text-slate-200'>
                  Stay in the know of the latest
                </Text>
                <Text variant='subtitle' color='text-white'>
                  Join our Newsletter
                </Text>
              </div>
              <Button
                isPrimary
                size='small'
                className='rounded-[8px] pointer-events-none'
              >
                <Text variant='smallSemi' color='text-white'>
                  Sign up now
                </Text>
              </Button>
            </div>
          </div>
          <div
            className={classNames(
              'absolute right-[10px]',
              'grid grid-cols-2 place-items-center gap-[20px]',
              'translate-x-[40%]',
            )}
          >
            <div
              className={classNames(
                'flex flex-col gap-[20px]',
                'translate-y-[-40px]',
              )}
            >
              <NewsletterCard
                title='Regulatory News in UAE, South Korea, China and Canada'
                image='/images/newsletter-2.png'
              />
              <NewsletterCard
                title='Cosmetic Regulatory Updates in China, South Korea and the EU'
                image='/images/newsletter-5.png'
                imageClassName='[object-position:calc(50%-30px)_center]'
              />
            </div>
            <div className='flex flex-col gap-[20px]'>
              <NewsletterCard
                title='SCCS Opinions, PFAS Ban in New Mexico and Updates in China'
                image='/images/newsletter-1.png'
              />
              <NewsletterCard
                title='ECHA Octocrylene Consultation and More in China and Canada'
                image='/images/newsletter-3.png'
              />
              <NewsletterCard
                title='Australian TGA Publishes Guidance on SPF Testing, FDA Launches Adverse Event Dashboard and More'
                image='/images/newsletter-4.png'
              />
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};
